import { Component } from '@angular/core';
import { IonIcon, IonLabel, IonTabBar, IonTabButton, IonTabs } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { constructOutline, informationCircleOutline, newspaperOutline, peopleOutline } from 'ionicons/icons';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-global-start-screen-page',
  templateUrl: './global-start-screen-page.component.html',
  standalone: true,
  imports: [IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, TranslatePipe],
})
export class GlobalStartScreenPageComponent {
  constructor() {
    addIcons({ constructOutline, newspaperOutline, informationCircleOutline, peopleOutline });
  }
}
